import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import PatientScheduleWithoutPaidContainer from 'app/containers/Accounting/PatientScheduleWithoutPaid'

const PatientScheduleWithoutPaidContainerCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.manage_customer_debt)}</PageTitle>
      <PatientScheduleWithoutPaidContainer />
    </>
  )
}
const AccountingPatientScheduleWithoutPaid = memo(
  PatientScheduleWithoutPaidContainerCpn,
  isEqual,
)

export default AccountingPatientScheduleWithoutPaid
